var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsdt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0195 11.9439C24.0299 14.3169 23.3358 16.6398 22.025 18.6187C20.7141 20.5976 18.8453 22.1437 16.6549 23.0614C14.4645 23.9792 12.0509 24.2274 9.71927 23.7747C7.38768 23.3219 5.24282 22.1886 3.55594 20.518C1.86906 18.8473 0.715923 16.7144 0.242347 14.389C-0.231228 12.0636 -0.00396777 9.65012 0.895389 7.45375C1.79474 5.25738 3.3258 3.37679 5.29495 2.04979C7.26409 0.722794 9.58288 0.00898996 11.9581 -0.00135077C15.143 -0.0152166 18.2029 1.23548 20.4649 3.47563C22.7268 5.71578 24.0054 8.76188 24.0195 11.9439Z",
    fill: "#50AF95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4243 12.9321C13.3447 12.938 12.9337 12.9626 12.0169 12.9626C11.2877 12.9626 10.77 12.9407 10.5883 12.9321C7.7703 12.8081 5.66689 12.3175 5.66689 11.7302C5.66689 11.1429 7.7703 10.653 10.5883 10.527V12.4435C10.7726 12.4568 11.3003 12.4879 12.0295 12.4879C12.9045 12.4879 13.3427 12.4514 13.4216 12.4442V10.5283C16.2337 10.6536 18.3325 11.1442 18.3325 11.7302C18.3325 12.3162 16.2343 12.8068 13.4216 12.9314L13.4243 12.9321ZM13.4243 10.3301V8.61518H17.3487V6H6.6639V8.61518H10.5877V10.3295C7.39841 10.476 5 11.1077 5 11.8648C5 12.6218 7.39841 13.2529 10.5877 13.4001V18.8956H13.4236V13.3981C16.6056 13.2516 19 12.6205 19 11.8641C19 11.1077 16.6076 10.4766 13.4236 10.3295L13.4243 10.3301Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/usdt.616fb3a8ac12a5839e1e264231ecc95d.svg";
export { ForwardRef as ReactComponent };